import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Field, FieldArray, reduxForm, SubmissionError } from "redux-form";
import * as cc from "currency-codes";
import LoadingProgress from "../components/LoadingProgress";

import Box from "../components/Box";

import { fetchContract, updateContract } from "../actions/contracts";
import { fetchMachines, resetMachines } from "../actions/machines";
import { fetchCustomers } from "../actions/customers";
import { fetchCalendarsName } from "../actions/calendars";

import {
  renderInputField,
  renderSelectField,
  renderTextAreaField,
} from "../utils/forms";
import QRZonesList from "../components/QRZonesList";
import ToggleSwitch from "../components/ToggleSwitch";
import "../styles/ContractDetailsView.css";

class ContractEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      fCustomers: null,
      fMachines: null,
      customerSelected: "",
      showDynamicField: false,
      hybridMode: false,
    };

    this.load = this.load.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {
      fetchContract,
      fetchMachines,
      fetchCustomers,
      fetchCalendarsName,
      match,
    } = this.props;

    fetchContract(match.params.id);
    fetchCalendarsName();
    fetchMachines();
    fetchCustomers();

    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { contract, machines, customers } = props;

    if (!this.state.loaded && contract && machines && customers) {
      this.setState({
        loaded: true,
        customerSelected: contract.Customer._id,
        hybridMode: contract.HybridMode || false,
        fMachines: machines.filter(
          (machine) =>
            machine.Customer === undefined ||
            machine._id === contract.Machine._id,
        ),
      });
    }
  }

  submit(props) {
    const { updateContract, contract } = this.props;

    // Convert hours + minutes into total minutes
    const hours = parseInt(props.hours || 0, 10);
    const minutes = parseInt(props.minutes || 0, 10);
    props.TimeSlots = hours * 60 + minutes;

    // Optional: clean up the original inputs if not needed by backend
    delete props.hours;
    delete props.minutes;

    props.Executor = this.props.fullname;

    return updateContract(contract._id, props).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  renderItems(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Artículo</th>
                <th scope="col">Precio (PVP)</th>
                <th scope="col">Comisión Cliente (%)</th>
                <th scope="col">Stock</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((member, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${member}.item`}
                      component={renderSelectField}
                    >
                      <option value="" key="default">
                        Selecciona un artículo...
                      </option>
                      <option value="LOCKERBNS" key="LOCKERBNS">
                        Standard
                      </option>
                      <option value="LOCKERCNS" key="LOCKERCNS">
                        Standard Carga
                      </option>
                      <option value="LOCKERBWS" key="LOCKERBWS">
                        Standard XL
                      </option>
                      <option value="LOCKERCWS" key="LOCKERCWS">
                        Standard Carga XL
                      </option>
                      <option value="LOCKERBNM" key="LOCKERBNM">
                        Medium
                      </option>
                      <option value="LOCKERCNM" key="LOCKERCNM">
                        Medium Carga
                      </option>
                      <option value="LOCKERBWM" key="LOCKERBWM">
                        Medium XL
                      </option>
                      <option value="LOCKERCWM" key="LOCKERCWM">
                        Medium Carga XL
                      </option>
                      <option value="LOCKERBNL" key="LOCKERBNL">
                        Large
                      </option>
                      <option value="LOCKERCNL" key="LOCKERCNL">
                        Large Carga
                      </option>
                      <option value="LOCKERBWL" key="LOCKERBWL">
                        Large XL
                      </option>
                      <option value="LOCKERCWL" key="LOCKERCWL">
                        Large Carga XL
                      </option>
                      <option value="LOCKERBNXL" key="LOCKERBNXL">
                        Large 4
                      </option>
                      <option value="LOCKERCNXL" key="LOCKERCNXL">
                        Large 4 Carga
                      </option>
                      <option value="LOCKERBWXL" key="LOCKERBWXL">
                        Large 4 XL
                      </option>
                      <option value="LOCKERCWXL" key="LOCKERCWXL">
                        Large 4 Carga XL
                      </option>
                      <option value="LOCKERBN2XL" key="LOCKERBN2XL">
                        Large 5
                      </option>
                      <option value="LOCKERCN2XL" key="LOCKERCN2XL">
                        Large 5 Carga
                      </option>
                      <option value="LOCKERBW2XL" key="LOCKERBW2XL">
                        Large 5 XL
                      </option>
                      <option value="LOCKERCW2XL" key="LOCKERCW2XL">
                        Large 5 Carga XL
                      </option>
                      <option value="LOCKERBN3XL" key="LOCKERBN3XL">
                        Ski
                      </option>
                      <option value="LOCKERCN3XL" key="LOCKERCN3XL">
                        Ski Carga
                      </option>
                      <option value="LOCKERBW3XL" key="LOCKERBW3XL">
                        Ski XL
                      </option>
                      <option value="LOCKERCW3XL" key="LOCKERCW3XL">
                        Ski Carga XL
                      </option>
                      {/* Voucher/Coupon Locker Types */}
                      <option value="LOCKERXNS" key="LOCKERXNS">
                        Voucher Standard (X)
                      </option>
                      <option value="LOCKERXWS" key="LOCKERXWS">
                        Voucher Standard XL (X)
                      </option>
                      <option value="LOCKERXNM" key="LOCKERXNM">
                        Voucher Medium (X)
                      </option>
                      <option value="LOCKERXWM" key="LOCKERXWM">
                        Voucher Medium XL (X)
                      </option>
                      <option value="LOCKERXNL" key="LOCKERNL">
                        Voucher Large (X)
                      </option>
                      <option value="LOCKERXWL" key="LOCKERWL">
                        Voucher Large XL (X)
                      </option>
                      <option value="LOCKERXNXL" key="LOCKERNXL">
                        Voucher Large 4 (X)
                      </option>
                      <option value="LOCKERXWXL" key="LOCKERWXL">
                        Voucher Large 4 XL (X)
                      </option>
                      <option value="LOCKERXN2XL" key="LOCKERXN2XL">
                        Voucher Large 5 (X)
                      </option>
                      <option value="LOCKERXW2XL" key="LOCKERXW2XL">
                        Voucher Large 5 XL (X)
                      </option>
                      <option value="LOCKERXN3XL" key="LOCKERXN3XL">
                        Voucher Ski (X)
                      </option>
                      <option value="LOCKERXW3XL" key="LOCKERXW3XL">
                        Voucher Ski XL (X)
                      </option>
                      <option value="TUMBONAS" key="TUMBONAS">
                        Tumbonas
                      </option>
                      <option value="FLOTADORES" key="FLOTADORES">
                        Flotadores
                      </option>
                      <option value="FLOTADORESHALFDAY" key="FLOTADORESHALFDAY">
                        Flotadores Medio Día
                      </option>
                      <option value="FASTPASS" key="FASTPASS">
                        Fastpass
                      </option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${member}.price`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.comission`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <Field
                      name={`${member}.stock`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    );
  }

  handleShowDynamicField() {
    this.setState({
      showDynamicField: true,
    });
  }

  render() {
    const { loaded, fMachines, showDynamicField } = this.state;
    const {
      contract,
      customers,
      calendars,
      error,
      pristine,
      handleSubmit,
      submitting,
    } = this.props;

    if (!loaded || !customers || !fMachines || !calendars) {
      return <LoadingProgress />;
    }

    return (
      <div className="contract-details-view">
        <div className="contract-header">
          <div className="contract-title-section">
            <h1 className="contract-title">
              <i className="fas fa-edit mr-2"></i>
              <span className="text-vw-light">EDITAR CONTRATO </span>
              <span className="text-vw-dark">{contract.Machine.Serial}</span>
            </h1>
          </div>
        </div>

        <form onSubmit={handleSubmit(this.submit)}>
          <div className="contract-content-grid">
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-dark">
                  <i className="fas fa-arrows-alt-h mr-2"></i>
                  Asignación
                </div>
                <div className="card-body-custom">
                  <Field
                    name="Customer"
                    component={renderSelectField}
                    label="Cliente"
                    onChange={(e) => {
                      this.setState({ customerSelected: e.target.value });
                    }}
                  >
                    {customers &&
                      customers
                        .filter(
                          (customer) =>
                            customer.Type === "GENERAL" ||
                            customer.Type === "LICENCIA_BASICA" ||
                            customer.Type === "LICENCIA_PRO",
                        )
                        .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                        .map((customer) => (
                          <option value={customer._id} key={customer._id}>
                            {customer.Fullname}
                          </option>
                        ))}
                  </Field>
                  <QRZonesList
                    customers={customers}
                    customerSelected={this.state.customerSelected}
                  />
                  <Field
                    name="Machine"
                    component={renderSelectField}
                    label="Máquina"
                  >
                    {fMachines.map((machine) => {
                      return (
                        <option value={machine._id} key={machine._id}>
                          {machine.Serial}
                        </option>
                      );
                    })}
                  </Field>
                  <Field
                    name="Location"
                    component={renderInputField}
                    type="text"
                    label="Localización (Lat, Lon)"
                  />
                </div>
              </div>
            </div>
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-light">
                  <i className="fas fa-cogs mr-2"></i>
                  Funcionamiento
                </div>
                <div className="card-body-custom">
                  <Field
                    name="WorkingMode"
                    component={renderSelectField}
                    label="Working Mode"
                  >
                    <option value="">Selecciona un modo...</option>
                    <option value="0">MTO DIARIO</option>
                    <option value="1">MTO DIARIO + SERVICIOS</option>
                    <option value="2">MTO DIARIO TIEMPO SIN PIN</option>
                    <option value="3">MTO DIARIO TIEMPO CON PIN</option>
                    <option value="4">OTO DIARIO SIN PIN</option>
                    <option value="5">OTO DIARIO CON PIN</option>
                    <option value="6">RESERVA ANTICIPADA</option>
                    <option value="7">TAQUILLAS AQUARIAZ</option>
                  </Field>
                  <div className="row">
                    <div className="col-md-6">
                      <Field
                        name="HybridMode"
                        component={ToggleSwitch}
                        label="Modo híbrido"
                        onChange={(e, newValue) =>
                          this.setState({ hybridMode: newValue })
                        }
                      />
                    </div>
                    <div className="col-md-6">
                      {this.state.hybridMode ? (
                        <div
                          className="alert alert-success"
                          style={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          <i className="fas fa-check-circle mr-1"></i>
                          <strong>Modo híbrido activo:</strong> La máquina
                          funcionará con el modo seleccionado y también
                          permitirá reserva anticipada simultáneamente.
                        </div>
                      ) : (
                        <div
                          className="alert alert-warning"
                          style={{ fontSize: "12px", marginTop: "10px" }}
                        >
                          <i className="fas fa-info-circle mr-1"></i>
                          <strong>Modo híbrido inactivo:</strong> La máquina
                          funcionará únicamente con el modo de trabajo
                          seleccionado.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Rango de tiempo</label>
                        <div
                          class="d-flex justify-content-center"
                          style={{ display: "flex", gap: "10px" }}
                        >
                          <Field
                            name="hours"
                            component="input"
                            type="number"
                            min="0"
                            placeholder="Horas"
                            style={{ width: "50px" }}
                            className="form-control w-25 text-center"
                          />
                          <span>:</span>
                          <Field
                            name="minutes"
                            component="input"
                            type="number"
                            min="0"
                            max="59"
                            placeholder="Minutos"
                            style={{ width: "50px" }}
                            className="form-control w-25 text-center"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <Field
                        name="TimeCourtesy"
                        component={renderSelectField}
                        label="Tiempo de cortesía"
                      >
                        <option value="">Selecciona un tiempo...</option>
                        <option value="0">0 minutos</option>
                        <option value="5">5 minutos</option>
                        <option value="10">10 minutos</option>
                        <option value="15">15 minutos</option>
                        <option value="30">30 minutos</option>
                      </Field>
                    </div>
                  </div>
                  <Field
                    name="DoorAccess"
                    component={renderInputField}
                    type="text"
                    label="Acceso a local"
                  />
                </div>
              </div>
            </div>
            <div className="contract-column">
              <div className="contract-card">
                <div className="card-header-custom bg-vw-dark">
                  <i className="fas fa-calendar-check mr-2"></i>
                  Condiciones
                </div>
                <div className="card-body-custom">
                  <Field
                    name="StartDate"
                    component={renderInputField}
                    type="date"
                    label="Fecha inicio"
                  />
                  <Field
                    name="EndDate"
                    component={renderInputField}
                    type="date"
                    label="Fecha fin"
                  />
                  <Field
                    name="Currency"
                    component={renderSelectField}
                    value="EUR"
                    label="Moneda"
                  >
                    {cc.codes().map((code) => {
                      const name = cc.code(code).currency;

                      return (
                        <option value={code} key={code}>
                          {`${code} - ${name}`}
                        </option>
                      );
                    })}
                  </Field>
                  <Field
                    name="ConversionRate"
                    component={renderInputField}
                    type="text"
                    label="Tasa de conversión"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="contract-card">
            <div className="card-header-custom bg-vw-light">
              <i className="fas fa-receipt mr-2"></i>
              Ticket
            </div>
            <div className="card-body-custom">
              <Field
                name="TicketHeader"
                component={renderInputField}
                type="text"
                label="Cabecera"
              />
              <Field
                name="TicketIVA"
                component={renderInputField}
                type="text"
                label="IVA (%)"
              />
              <Field
                name="TicketFooter"
                component={renderInputField}
                type="text"
                label="Footer"
              />
            </div>
          </div>
          <div className="contract-card">
            <div className="card-header-custom bg-vw-dark">
              <i className="fas fa-gavel mr-2"></i>
              Términos y condiciones
            </div>
            <div className="card-body-custom">
              <Field
                name="TermsLink"
                component={renderInputField}
                type="text"
                label="Terminos"
              />
            </div>
          </div>
          <div className="contract-card">
            <div className="card-header-custom bg-vw-light">
              <i className="fas fa-shopping-cart mr-2"></i>
              Artículos
            </div>
            <div className="card-body-custom">
              <div className="row">
                <div className="col-md-6">
                  <Field
                    name="Calendar"
                    component={renderSelectField}
                    label="Calendario de precios"
                  >
                    <option value="">Selecciona un calendario...</option>
                    {calendars &&
                      calendars
                        .sort((a, b) => a.Name.localeCompare(b.Name))
                        .map((calendar) => (
                          <option value={calendar._id} key={calendar._id}>
                            {calendar.Name}
                          </option>
                        ))}
                  </Field>
                </div>
                <div className="col-md-6">
                  <Field
                    name="LocalCalendar"
                    component={ToggleSwitch}
                    label="Calendario local (precios dinámicos)"
                  />
                </div>
              </div>
              <FieldArray name="Items" component={this.renderItems} />
            </div>
          </div>
          <div className="contract-card">
            <div className="card-header-custom bg-vw-dark">
              <i className="fas fa-comment-dots mr-2"></i>
              Mensaje en Start
            </div>
            <div className="card-body-custom">
              <Field
                name="StartMessage"
                component={renderInputField}
                type="text"
                label="Mensaje"
              />
            </div>
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <button
            className="btn bg-vw-light text-white btn-action save"
            type="submit"
            disabled={pristine || submitting}
          >
            Guardar
          </button>
        </form>
      </div>
    );
  }
}

ContractEditForm = reduxForm({
  form: "ContractEditForm",
  onSubmitSuccess: (result, dispatch, props) => {
    props.resetMachines();
    props.push(`/contracts/${result.response._id}`);
  },
  enableReinitialize: true,
})(ContractEditForm);

const mapStateToProps = (state) => {
  let StartDate = null;
  let EndDate = null;
  let Customer = null;
  let Machine = null;

  let hours = 0;
  let minutes = 0;

  if (state.contracts.contract && state.contracts.contract.TimeSlots != null) {
    hours = Math.floor(state.contracts.contract.TimeSlots / 60);
    minutes = state.contracts.contract.TimeSlots % 60;
  }

  if (state.contracts.contract) {
    StartDate = state.contracts.contract.StartDate;
    EndDate = state.contracts.contract.EndDate;
    Customer = state.contracts.contract.Customer._id;
    Machine = state.contracts.contract.Machine._id;
  }

  return {
    contract: state.contracts.contract,
    machines: state.machines.machines,
    customers: state.customers.customers,
    calendars: state.calendars.calendars,
    fullname: state.auth.fullname,
    initialValues: {
      ...state.contracts.contract,
      StartDate: new Date(StartDate).toISOString().substring(0, 10),
      EndDate: new Date(EndDate).toISOString().substring(0, 10),
      Customer: Customer,
      Machine: Machine,
      Calendar: state.contracts.contract?.Calendar?._id || "",
      Zone: state.contracts.contract?.Zone || "",
      hours,
      minutes,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchContract: bindActionCreators(fetchContract, dispatch),
  fetchCalendarsName: bindActionCreators(fetchCalendarsName, dispatch),
  updateContract: bindActionCreators(updateContract, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  resetMachines: bindActionCreators(resetMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContractEditForm);
